/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChargebeeResponse } from '../models/chargebee-response';
import { createOfflineInvoiceForProfile } from '../fn/purchase/create-offline-invoice-for-profile';
import { CreateOfflineInvoiceForProfile$Params } from '../fn/purchase/create-offline-invoice-for-profile';
import { createOneDaySubscriptionAfterPurchase } from '../fn/purchase/create-one-day-subscription-after-purchase';
import { CreateOneDaySubscriptionAfterPurchase$Params } from '../fn/purchase/create-one-day-subscription-after-purchase';
import { getPurchasePlans } from '../fn/purchase/get-purchase-plans';
import { GetPurchasePlans$Params } from '../fn/purchase/get-purchase-plans';
import { ProfileSubscription } from '../models/profile-subscription';
import { webhook } from '../fn/purchase/webhook';
import { Webhook$Params } from '../fn/purchase/webhook';

@Injectable({ providedIn: 'root' })
export class PurchaseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createOneDaySubscriptionAfterPurchase()` */
  static readonly CreateOneDaySubscriptionAfterPurchasePath = '/rest/profile/{id}/purchase/one-day-subsiption-after-purchase';

  /**
   * After succesfull purchase this API can be used to create one day subscription till Chargebee notify SmartHead (webhook) and real subscription is created.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneDaySubscriptionAfterPurchase()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOneDaySubscriptionAfterPurchase$Response(params: CreateOneDaySubscriptionAfterPurchase$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileSubscription>> {
    return createOneDaySubscriptionAfterPurchase(this.http, this.rootUrl, params, context);
  }

  /**
   * After succesfull purchase this API can be used to create one day subscription till Chargebee notify SmartHead (webhook) and real subscription is created.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneDaySubscriptionAfterPurchase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  createOneDaySubscriptionAfterPurchase(params: CreateOneDaySubscriptionAfterPurchase$Params, context?: HttpContext): Observable<ProfileSubscription> {
    return this.createOneDaySubscriptionAfterPurchase$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileSubscription>): ProfileSubscription => r.body)
    );
  }

  /** Path part for operation `createOfflineInvoiceForProfile()` */
  static readonly CreateOfflineInvoiceForProfilePath = '/rest/profile/{id}/purchase/offline-invoice/{planId}';

  /**
   * Create Invoice/Offline subscription for profile. If profile (e.g. customer) does not exists in Chargebee - it is created. Profile cannot have any active subscription.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOfflineInvoiceForProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOfflineInvoiceForProfile$Response(params: CreateOfflineInvoiceForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createOfflineInvoiceForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Invoice/Offline subscription for profile. If profile (e.g. customer) does not exists in Chargebee - it is created. Profile cannot have any active subscription.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOfflineInvoiceForProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOfflineInvoiceForProfile(params: CreateOfflineInvoiceForProfile$Params, context?: HttpContext): Observable<void> {
    return this.createOfflineInvoiceForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPurchasePlans()` */
  static readonly GetPurchasePlansPath = '/rest/purchase/plans';

  /**
   * Get list of purchase plans - plans which can users buy. Plans are feteched from Chargbee, cached, filtered - show only plans witch have set 'online-platform-enabled' flag to true.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPurchasePlans()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchasePlans$Response(params?: GetPurchasePlans$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChargebeeResponse>>> {
    return getPurchasePlans(this.http, this.rootUrl, params, context);
  }

  /**
   * Get list of purchase plans - plans which can users buy. Plans are feteched from Chargbee, cached, filtered - show only plans witch have set 'online-platform-enabled' flag to true.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPurchasePlans$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPurchasePlans(params?: GetPurchasePlans$Params, context?: HttpContext): Observable<Array<ChargebeeResponse>> {
    return this.getPurchasePlans$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ChargebeeResponse>>): Array<ChargebeeResponse> => r.body)
    );
  }

  /** Path part for operation `webhook()` */
  static readonly WebhookPath = '/rest/purchase/webhook';

  /**
   * All ChargeBee events (created customer, subscription, payment done ...) are procesed with this endpoint. Secured by HTTP Basic Auth.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `webhook()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhook$Response(params?: Webhook$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return webhook(this.http, this.rootUrl, params, context);
  }

  /**
   * All ChargeBee events (created customer, subscription, payment done ...) are procesed with this endpoint. Secured by HTTP Basic Auth.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `webhook$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  webhook(params?: Webhook$Params, context?: HttpContext): Observable<void> {
    return this.webhook$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
